import React, { useState, useEffect } from "react"
import { useAuthContext } from "contexts/AuthContext"
import Avatar from "@mui/material/Avatar"
import { styles } from "./TaecherAvatar.styles"
import { Stack, Typography } from "@mui/material"

export default function TeacherAvatar(props) {
  const { selectedGroupData } = useAuthContext()
  const [teacher, setTeacher] = useState()

  useEffect(() => {
    if (
      selectedGroupData?.teachers &&
      Array.isArray(selectedGroupData?.teachers)
    ) {
      const teacher = selectedGroupData?.teachers?.filter(
        (teacher) => teacher.isMainTeacher
      )
      if (teacher && teacher.length > 0) {
        setTeacher({
          teacherAvatar: teacher[0].avatar,
          teacherName: `${teacher[0].name} ${teacher[0].lastName}`,
        })
      }
    }
  }, [selectedGroupData])

  return (
    <Stack
      alignItems={"center"}
      justifyContent={"center"}
      className="teacherAvatar"
    >
      <Avatar
        alt={teacher?.teacherName || ""}
        src={
          teacher?.teacherAvatar ||
          `${window.location.origin}/avatars/default.png`
        }
        sx={[styles.root, props?.sx]}
      />
      {props.showInfo && <Typography mt={1}>{teacher?.teacherName}</Typography>}
      {props.showInfo && <Typography>{selectedGroupData?.name}</Typography>}
    </Stack>
  )
}
